import React from "react";

function QueryModelTypeSelect({ value, onChange }) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="queryModelTypeSelect" className="form-label">
        Query Model Type
      </label>
      <select className="form-select" id="queryModelTypeSelect" value={value} onChange={handleChange}>
        <option value="">Select Model Type</option>
        <option value="Id::CompanyJob">Company Job</option>
        <option value="Id::MediaItem">Media Item</option>
        <option value="Id::MediaJob">Media Job</option>
        <option value="Id::MediaOutlet">Media Outlet</option>
        <option value="Id::Profile::MediaProfile">Media Profile</option>
        <option value="Id::Profile::Promoter">Promoter Profile</option>
        <option value="Id::PromoEntity::Company">Promo Company</option>
        <option value="Id::PromoEntity::Expert">Promo Expert</option>
        <option value="Id::PromoEntity::Product">Promo Product</option>
        <option value="Id::Quote">Quote</option>
        <option value="Interact::Pitch">Pitch</option>
        <option value="Interact::Request">Request</option>
        <option value="Enrich::PublicPitch">Public Pitch</option>
      </select>
    </div>
  );
}

export default QueryModelTypeSelect;
